import { render, staticRenderFns } from "./PatientInput.vue?vue&type=template&id=ba8ed73a&scoped=true&"
import script from "./PatientInput.vue?vue&type=script&lang=js&"
export * from "./PatientInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientInput.vue?vue&type=style&index=0&id=ba8ed73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ed73a",
  null
  
)

export default component.exports